import React, { useEffect, useCallback, useRef, useState } from "react";
// import "./CustomerPaymentLedger.css";
import { Select, DatePicker, Form, Table, Button, Spin, Input } from "antd";
import { FilterFilled, SearchOutlined } from "@ant-design/icons"
import { useSelector, useDispatch } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { getRegion } from "../../redux/actions/region.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getGender } from "../../redux/actions/gender.action";
import { getAllCompany } from "../../redux/actions/companyAccess";
import { getAllScmBrand } from "../../redux/actions/scmBrand.action";
import { getCustomerType } from "../../redux/actions/customerType.action";
import { loadCustomers } from "../../redux/actions/customerForm";
import { getCustomerAccountStatement, getCustomerPaymentReport } from "../../redux/actions/customerPayment.action";
import logo from "../../assets/images/logo.png";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import csv from "../../assets/images/csv.png";
import pdf from "../../assets/images/PDF_file_icon.svg.png";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import { TabTitle } from "../../utils/GeneralFunction";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ExcelJS from "exceljs";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { createInvoicePdfDownload } from "../../redux/actions/invoiceEmail.action";
import notification from "../../utils/notification";

const { Option } = Select;
const dateFormatList = ["MM/DD/YYYY"];

const CustomerAccountStatement = ({ token }) => {
  TabTitle("Customer Account Statement");
  const userName = ReadCookie("name");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const focusInput = useRef(null);
  const tableRef = useRef(null);
  const [select, setSelect] = useState("All");
  const [loader, setLoader] = useState(false);
  const [customerList, setCutomerList] = useState([]);
  const [customerId, setCutomerId] = useState([]);
  const [excelData, setExcelData] = useState([])
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const {
    gender,
    region,
    companyAll,
    scmBrand,
    customerForms,
    getBussinessDashboardReducer,
    customerAccountStatement,
    invoicePdf
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const [customer, setCustomer] = useState("All");
  const { submited } = useParams();



  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null, null)).then(
      (res) => {
        if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
          setCustomer(res?.payload?.data);
        }
      }
    );
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);
  let rbalance = 0;

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let customer_id = query.get("customer_id");
  let customer_name = query.get("customer_name");

  useEffect(() => {

    let values = {
      customer_id: customer_id,
      from_date: "01-01-2010",
      to_date: moment().endOf('year'),
      status: "U",
      customer_name: customer_name
    };

    form.setFieldsValue({
      customer_id: values.customer_id,
      from_date: moment(values.from_date),
      to_date: moment(values.to_date),
      status: "U"
    });
    if (customer_id) {
      setLoader(true)
      dispatch(getCustomerAccountStatement(token, values)).then((res) => {

        let filterData = res?.payload?.data && res?.payload?.data.filter((elem) => {
          return elem.invoice_header_id != "0";
        })

        let filterZeroId = res?.payload?.data && res?.payload?.data.filter((elem) => {
          return elem.invoice_header_id == "0";
        })

        const seq1Total = res?.payload?.data
          ?.filter(item => item.seqno === 1)
          ?.reduce((sum, item) => sum + parseFloat(item?.opening_balance || 0), 0);

        // seq 2 total
        const seq2Total = res?.payload?.data
          ?.filter(item => item.seqno === 2)
          ?.reduce((sum, item) => sum + parseFloat(item?.opening_balance || 0), 0);


        setCutomerId(res?.payload?.data)
        setCutomerList(res?.payload?.data)
        setLoader(false);
        downloadExcelFileData(res?.payload?.data, seq1Total, seq2Total);

        dispatch(loadCustomers(token, null, null, null, null, null, customer_name, null, null, null, null, null, null, null, null, null, null, null, null)).then(
          (res) => {
            if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
              setCustomer(res?.payload?.data);
            }
          }
        );
      })
    }
  }, [customer_id])

  const onFinish = async (e) => {
    setLoader(true)
    await form.validateFields().then((values) => {
      dispatch(getCustomerAccountStatement(token, values)).then((res) => {


        const seq1Total = res?.payload?.data
          ?.filter(item => item.seqno === 1)
          ?.reduce((sum, item) => sum + parseFloat(item?.opening_balance || 0), 0);

        // seq 2 total
        const seq2Total = res?.payload?.data
          ?.filter(item => item.seqno === 2)
          ?.reduce((sum, item) => sum + parseFloat(item?.opening_balance || 0), 0);


        setCutomerId(res?.payload?.data)
        setCutomerList(res?.payload?.data)
        setLoader(false);
        downloadExcelFileData(res?.payload?.data, seq1Total, seq2Total);
      })
    });
  };

  useEffect(() => {
    dispatch(getRegion(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
    dispatch(getAllCompany(token));
    dispatch(getAllScmBrand(token));
    dispatch(getCustomerType(token));
  }, [dispatch, menuId, token]);


  const handlePrint = () => {
    const css = '@page { margin-top: 25px; margin-bottom: 25px; margin-right: 25px}';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style);
  };


  function downloadExcelFileData(data, seq1Total, seq2Total) {

    setExcelData(
      data.map((v) => {
        return {
          "Customer": v.customer_name,
          "Transaction Type": v.transtype,
          "Date": v.document_date ? moment(v.document_date).format("MM-DD-YYYY") : "",
          "Document #": v.document_no,
          "PO #": v.reference_no,
          "Due Date": v.due_date ? moment(v.due_date).format("MM-DD-YYYY") : "",
          "Age": v.age,
          "Open Balance": numeral(v.opening_balance).format("$0,0.00"),
          "R.Balance": numeral(v.r_balance).format("$0,0.00"),
          "Gender": v.gender_name,
          "Term": v.term_name
        };
      }).concat([
        {},

        {
          "Customer": "Available Credit",
          "Transaction Type": numeral(seq1Total).format("$0,0.00"),
          "Date": "Open Invoices",
          "Document #": numeral(seq2Total).format("$0,0.00"),
        },
      ])
    )
  }


  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Customer Ledger');

    const data = customerAccountStatement?.payload?.data || [];

    // =========================
    // 🔥 TOTALS
    // =========================
    const seq1Total = data
      .filter(item => item.seqno === 1)
      .reduce((sum, item) => sum + Number(item.opening_balance || 0), 0);

    const seq2Total = data
      .filter(item => item.seqno === 2)
      .reduce((sum, item) => sum + Number(item.opening_balance || 0), 0);

    const customerName = data[0]?.customer_name || "";

    // =========================
    // 🔥 1. COLUMNS FIRST
    // =========================
    worksheet.columns = [
      // { header: 'Customer', key: 'customer_name', width: 25 },
      { header: 'Transaction Type', key: 'transtype', width: 25 },
      { header: 'Date', key: 'document_date', width: 25 },
      { header: 'Document #', key: 'document_no', width: 25 },
      { header: 'PO #', key: 'reference_no', width: 20 },
      { header: 'Due Date', key: 'due_date', width: 15 },
      { header: 'Age', key: 'age', width: 20 },
      {
        header: 'Open Balance',
        key: 'opening_balance',
        width: 18,
        style: { numFmt: '"$"#,##0.00' }
      },
      {
        header: 'R.Balance',
        key: 'r_balance',
        width: 18,
        style: { numFmt: '"$"#,##0.00' }
      },
      { header: 'Gender', key: 'gender_name', width: 20 },
      { header: 'Term', key: 'term_name', width: 20 }
    ];

    // =========================
    // 🔥 2. DATA ROWS
    // =========================
    data.forEach((v) => {
      worksheet.addRow({
        // customer_name: v.customer_name,
        transtype: v.transtype,
        document_date: v.document_date ? moment(v.document_date).format("MM-DD-YYYY") : "",
        document_no: v.document_no,
        reference_no: v.reference_no,
        due_date: v.due_date ? moment(v.due_date).format("MM-DD-YYYY") : "",
        age: v.age,
        opening_balance: Number(v.opening_balance) || 0,
        r_balance: Number(v.r_balance) || 0,
        gender_name: v.gender_name,
        term_name: v.term_name,
      });
    });

    // =========================
    // 🔥 3. HEADER INSERT LAST (IMPORTANT FIX)
    // =========================
    worksheet.insertRow(1, [
      "Name:",
      customerName,
      "Available Credit:",
      Number(seq1Total),
      "Open Invoices:",
      Number(seq2Total),
    ]);

    const headerRow = worksheet.getRow(1);
    [1, 3, 5].forEach(i => {
      headerRow.getCell(i).font = { bold: true };
    });

    const columnHeaderRow = worksheet.getRow(2);
    columnHeaderRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    headerRow.getCell(4).numFmt = '"$"#,##0.00';
    headerRow.getCell(6).numFmt = '"$"#,##0.00';

    headerRow.alignment = { vertical: "middle" };

    // =========================
    // 🔥 TOTAL ROW
    // =========================
    const totalBalance = data.reduce(
      (sum, item) => sum + Number(item.opening_balance || 0),
      0
    );

    const totalRow = worksheet.addRow({
      age: "TOTAL",
      opening_balance: totalBalance,
    });

    totalRow.font = { bold: true };

    // =========================
    // 🔥 DOWNLOAD
    // =========================
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'Customer-Account-Statement.xlsx';
    link.click();
  };



  function generatePDF() {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4"
    });

    const data = customerAccountStatement?.payload?.data || [];

    const filteredData = data.filter(
      (elem) => elem.invoice_header_id != "0"
    );

    const customerName = data[0]?.customer_name || "";

    // =========================
    // 🔥 TOTALS (SEQ)
    // =========================
    const seq1Total = data
      .filter(item => item.seqno === 1)
      .reduce((sum, item) => sum + Number(item.opening_balance || 0), 0);

    const seq2Total = data
      .filter(item => item.seqno === 2)
      .reduce((sum, item) => sum + Number(item.opening_balance || 0), 0);

    // =========================
    // 🔥 HEADER ROW (YOUR NEW ROW)
    // =========================
    doc.setFontSize(10);

    doc.text(`Name: ${customerName}`, 14, 10);
    // doc.text(`Available Credit: ${numeral(seq1Total).format("0,0.00")}`, 80, 10);
    // doc.text(`Open Invoices: ${numeral(seq2Total).format("0,0.00")}`, 150, 10);

    const y = 10;
    const right = doc.internal.pageSize.getWidth() - 14;

    const ac = `Available Credit: ${numeral(seq1Total).format("$0,0.00")}`;
    const oi = `Open Invoices: ${numeral(seq2Total).format("$0,0.00")}`;

    // pehle Open Invoices (right edge pe)
    doc.text(oi, right, y, { align: "right" });

    // phir Available Credit (uske left me)
    doc.text(ac, right - doc.getTextWidth(oi) - 10, y, { align: "right" });


    // =========================
    // TABLE COLUMNS
    // =========================
    const columns = [
      // "Customer",
      "Transaction Type",
      "Date",
      "Document #",
      "PO #",
      "Due Date",
      "Age",
      "Open Balance",
      "R.Balance",
      "Gender",
      "Term"
    ];

    // =========================
    // TABLE ROWS
    // =========================
    const rows = [];

    data.forEach(v => {
      rows.push([
        // v.customer_name,
        v.transtype,
        v.document_date ? moment(v.document_date).format("MM-DD-YYYY") : "",
        v.document_no,
        v.reference_no,
        v.due_date ? moment(v.due_date).format("MM-DD-YYYY") : "",
        v.age,
        numeral(v.opening_balance).format("$0,0.00"),
        numeral(v.r_balance).format("$0,0.00"),
        v.gender_name,
        v.term_name
      ]);
    });

    // =========================
    // TOTAL ROW
    // =========================
    const total = data.reduce(
      (acc, item) => acc + Number(item.opening_balance || 0),
      0
    );

    rows.push([
      "", "", "", "", "", "TOTAL", numeral(total).format("$0,0.00")
    ]);

    // =========================
    // TABLE RENDER
    // =========================
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 18, // 👈 important (header ke baad spacing)
      styles: {
        fontSize: 7
      }
    });

    // =========================
    // SAVE
    // =========================
    doc.save("Customer-Account-Statement.pdf");
  }


  const column = [
    {
      title: "S#",
      align: "center",
      width: "60px",
      render: (text, record, index) => {
        return index + 1;
      },
    },
    {
      title: "Transaction Type",
      dataIndex: "transtype",
      key: "transtype",
      // render: (text, record) => {
      //   return <>{numeral(text).format('0,0')}</>
      // },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.transtype !== null) {
          return record.transtype
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.transtype !== null) & (b.transtype !== null)) {
          return a.transtype.localeCompare(b.transtype);
        }
      },
    },

    {
      title: "Date",
      dataIndex: "document_date",
      key: "document_date",
      render: (text, record) => {
        return text ? moment(text).format("MM-DD-YYYY") : "";
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.document_date !== null) {
          return record.document_date
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.document_date !== null) & (b.document_date !== null)) {
          return a.document_date - b.document_date;
        }
      },
    },
    {
      title: "Document #",
      dataIndex: "document_no",
      key: "document_no",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.document_no !== null) {
          return record.document_no
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.document_no !== null) & (b.document_no !== null)) {
          return a.document_no - b.document_no;
        }
      },
    },
    {
      title: "PO #",
      dataIndex: "reference_no",
      key: "reference_no",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.reference_no !== null) {
          return record.reference_no
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.reference_no !== null) & (b.reference_no !== null)) {
          return a.reference_no - b.reference_no;
        }
      },
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      render: (text, record) => {
        return text ? moment(text).format("MM-DD-YYYY") : "";
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.due_date !== null) {
          return record.due_date
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.due_date !== null) & (b.due_date !== null)) {
          return a.due_date - b.due_date;
        }
      },
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.age !== null) {
          return record.age
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.age !== null) & (b.age !== null)) {
          return a.age - b.age;
        }
      },
    },
    {
      title: "Open Balance",
      dataIndex: "opening_balance",
      key: "opening_balance",
      align: "right",
      render: (text, record) => {
        return <>${numeral(text).format("0,0.00")}</>;
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.opening_balance !== null) {
          return record.opening_balance
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.opening_balance !== null) & (b.opening_balance !== null)) {
          return a.opening_balance - b.opening_balance;
        }
      },
    },
    {
      title: "R.Balance",
      dataIndex: "r_balance",
      key: "r_balance",
      align: "right",
      render: (text, record) => {
        return <>${numeral(text).format("0,0.00")}</>;
      },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.r_balance !== null) {
          return record.r_balance
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.r_balance !== null) & (b.r_balance !== null)) {
          return a.r_balance - b.r_balance;
        }
      },
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      // render: (text, record) => {
      //   return <>{numeral(text).format('0,0')}</>
      // },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.gender_name !== null) {
          return record.gender_name
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.gender_name !== null) & (b.gender_name !== null)) {
          return a.gender_name.localeCompare(b.gender_name);
        }
      },
    },
    {
      title: "Term",
      dataIndex: "term_name",
      key: "term_name",
      // render: (text, record) => {
      //   return <>{numeral(text).format('0,0')}</>
      // },
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              allowClear
              autoFocus
              className="pop-search-gen pop-220 w-100"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
            />
          </>
        );
      },
      filterIcon: (filtered) =>
        filtered ? <FilterFilled /> : <SearchOutlined />,
      onFilter: (value, record) => {
        if (record.term_name !== null) {
          return record.term_name
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      },
      sorter: (a, b) => {
        if ((a.term_name !== null) & (b.term_name !== null)) {
          return a.term_name.localeCompare(b.term_name);
        }
      },
    },
  ];

  // const total_invoice_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.invoice_amount), 0)
  // const total_note_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.note_amount_us), 0)
  // // const total_payment_us = customerList.reduce((acc, item, index) => acc + parseFloat(item.payment_us), 0)
  // // const total_Adj_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.refund_amount_us), 0)
  // const total_balance = customerList.reduce((acc, item, index) => acc + parseFloat(item.opening_balance), 0)
  const total_balance = (customerAccountStatement?.payload?.data || []).reduce((acc, item) => {
    const val = Number(item.opening_balance);
    return !isNaN(val) ? acc + val : acc;
  }, 0);
  // const total_amount_paid = customerList.reduce((acc, item, index) => acc + parseFloat(item.amount_paid), 0)
  // const total_adjustment = customerList.reduce((acc, item, index) => acc + parseFloat(item.payment_adjustment), 0)
  // const total_refund_amount = customerList.reduce((acc, item, index) => acc + parseFloat(item.refund_amount), 0)
  // const total_credit_use = customerList.reduce((acc, item, index) => acc + parseFloat(item.credituse), 0)


  let result =
    selectedRows.length > 0 &&
    selectedRows?.reduce(function (r, a) {
      r[a.customer_id] = r[a.customer_id] || [];
      r[a.customer_id].push(a);
      return r;
    }, Object.create(null));

  const selectedRow = result ? Object.values(result) : [];

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {

    setSelectedRows(selectedRows)
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,

    // 🔥 THIS IS THE MAIN PART
    getCheckboxProps: (record) => ({
      disabled: record.transtype !== "Invoice", // ❌ disable non-invoice rows
    }),
  };

  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRows(selectedRows);
  //   },
  //   getCheckboxProps: (record) => ({
  //     disabled: record.transtype !== "Invoice", // ❌ disable for others
  //   }),
  // };

  const downloadInvoice = () => {
    selectedRow.map((resp) => {
      dispatch(createInvoicePdfDownload(token, resp)).then((res) => {
        if (res?.type === "GET_PDF_DOWNLOAD_SUCCESS") {
          const pdfBlob = new Blob([res?.payload], { type: "application/pdf" });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.download = "InvoiceReport.pdf";
          link.click();
          URL.revokeObjectURL(pdfUrl);
          notification("success", "Invoice Downloaded Successfully");
          setSelectedRows([]);
          setSelectedRowKeys([]);
          setCutomerList([]);
        }
      });
    })

  }

  const seq1Total = customerAccountStatement?.payload?.data
    .filter(item => item.seqno === 1)
    .reduce((sum, item) => sum + parseFloat(item.opening_balance || 0), 0);

  // seq 2 ka total
  const seq2Total = customerAccountStatement?.payload?.data
    .filter(item => item.seqno === 2)
    .reduce((sum, item) => sum + parseFloat(item.opening_balance || 0), 0);



  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className="report-wrapper-main header_class business_class">
            <div className="row justify-content-between pb-2 ledger_print_ar">
              <div className="col-3 d-flex align-items-start  box-space">
                <div className="logobrand">
                  <img id="ImgLogo" alt="logo" src={logo} />
                </div>
              </div>

              <div className="col-4 box-space right-content-header text-right pb-0">
                <div className=" d-flex justify-content-end">
                  <div className=" d-flex printing_class mr-8">
                    <div className="print_icon printing_class">
                      <i
                        onClick={handlePrint}
                        id="Image1"
                        title="Print"
                        alt="Print"
                        src={btnPrint}
                        className="fa-solid fa-print"
                      ></i>
                    </div>
                    <div className="print_icon printing_class" >
                      <CSVLink
                        filename={"Customer-Account-Statement.csv"}
                        data={excelData}
                        onClick={() => {
                        }}
                      >
                        <input
                          type="image"
                          name="ImgExcel"
                          alt="Export to excel"
                          id="ImgExcel"
                          title="Export to excel"
                          src={csv}


                          style={{ borderWidth: "0px", height: "14px" }}
                        />
                      </CSVLink>
                    </div>
                    <div className="print_icon printing_class" >
                      <input
                        type="image"
                        name="ImgExcel"
                        alt="Export to Excel"
                        id="ImgExcel"
                        title="Export to Excel"
                        src={xlsx}
                        onClick={exportToExcel}

                        style={{ borderWidth: "0px", height: "14px" }}
                      />
                    </div>
                    <div className="print_icon printing_class" >
                      <input
                        type="image"
                        name="ImgPDF"
                        alt="Export to PDF"
                        id="ImgPDF"
                        title="Export to PDF"
                        src={pdf}
                        onClick={generatePDF}

                        style={{ borderWidth: "0px", height: "18px" }}
                      />
                      {/* <button onClick={() => generatePDF()}>Generate PDF</button> */}
                    </div>
                  </div>
                  <span style={{ fontWeight: "bolder" }}>
                    Customer Account Statement
                    <br />

                    <div className="printing_class123">
                      Rpt # 489
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            {/* Filters Table */}
            <div className="row ledger_print_ar">
              <div className="col business_header">
                <Form form={form} name="control-hooks" onFinish={onFinish}>
                  <div className="main_form row">

                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width30">
                          From:
                        </label>
                        <div className=" w-100">
                          <Form.Item
                            className="full_date"
                            name="from_date"
                          // initialValue={moment().startOf('year')}
                          >
                            <DatePicker
                              size="small"
                              // defaultValue={moment().format("MM-DD-YYYY")}
                              format={dateFormatList}
                              className={"input-width"}

                            />
                          </Form.Item>
                        </div>
                      </div>

                    </div>
                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label htmlFor="" className="labels width30">
                          To:
                        </label>
                        <div className=" w-100">
                          <Form.Item
                            className="full_date"
                            name="to_date"
                            initialValue={moment().endOf('year')}
                          >
                            <DatePicker
                              size="small"
                              defaultValue={moment().format("MM-DD-YYYY")}
                              format={dateFormatList}
                              className={"input-width"}

                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="main_form row">

                    <div className=" col-6">
                      <div className=" d-flex flex-row align-items-baseline">
                        <label className="labels width30">Customer:</label>
                        <div className=" w-100">
                          <Form.Item
                            name="customer_id"
                            rules={[
                              {
                                required: true,
                                message: "Customer is Required",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              optionFilterProp="children"
                              className={"select_Inputs"}
                              loading={customerForms.loading}

                              size="small"
                              onSearch={(value) => {
                                optimizedFn(value);
                              }}
                              ref={focusInput}
                              value={customer}
                              filterSort={(optionA, optionB) =>
                                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {customerForms?.payload?.data.map((item) => {
                                return (
                                  <Option
                                    key={item.customer_id}
                                  >
                                    {`${item.customer_name}`}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className=" col-6">

                      <div>
                        <Button
                          htmlType="submit"
                          type="primary"
                          className="submit-btn-btm "
                        >
                          Submit
                        </Button>
                      </div>
                      {
                        selectedRows.length > 0 ? (
                          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }}>
                            <Button
                              disabled={invoicePdf.loading ? true : false}
                              type="primary" onClick={downloadInvoice}>
                              {invoicePdf.loading ? <><Spin size="small" className="customer_payment_ledger_btn_loader mr-1" /> Download Pdf ({selectedRows.length})</> : `Download Pdf (${selectedRows.length})`}
                            </Button>
                          </div>
                        ) : null
                      }
                    </div>
                  </div>
                </Form>
              </div>
            </div>
            {/* Render Data Table */}
          </div>
          <div className="table_content customer_ledger_table_content ledger_print omsTable"

            style={{ maxWidth: '1500px' }}
          >
            <div className="">
              {customerAccountStatement?.payload?.data !== undefined ? (
                customerAccountStatement?.payload?.data.length > 0 ? (
                  <>
                    <div className="data_Table ledger_print_ar">
                      <div >
                        <div

                          style={{ margin: "0 auto", paddingTop: "10px" }}
                        >
                          <table id="Table1" cellPadding="3" cellSpacing="0" align="center" className="tablestyleControls" style={{ fontSize: "10px" }}>
                            <tbody>
                              <tr>
                                {/* Customer */}
                                <td className="font_weight" style={{ width: "20px" }}>Name :</td>
                                <td style={{ width: "200px" }}>
                                  <b className="font_weight">
                                    {customerAccountStatement?.payload?.data[0].customer_name}
                                  </b>
                                </td>

                                {/* Other Credit */}
                                <td className="font_weight" style={{ width: "50px" }}>Available Credit:</td>
                                <td style={{ width: "50px" }}>
                                  <b className="font_weight">
                                    ${numeral(seq1Total).format("0,0.00")}
                                  </b>
                                </td>

                                {/* Unapplied Amount */}
                                <td className="font_weight" style={{ width: "50px" }}>Open Invoices:</td>
                                <td style={{ width: "50px" }}>
                                  <b className="font_weight">
                                    ${numeral(seq2Total).format("0,0.00")}
                                  </b>
                                </td>
                              </tr>
                            </tbody >
                          </table >
                        </div>
                      </div>
                    </div>

                    <Table
                      className="
                
                test04 mt-3 sales_report_res_table_intransit ledger_print omsTable hide_selection"
                      ref={tableRef}
                      size="small"
                      bordered={false}
                      type="company"
                      headerClassName='abc'
                      dataSource={customerAccountStatement?.payload?.data.length > 0 ? customerAccountStatement?.payload?.data : []}
                      columns={column}
                      loading={customerAccountStatement?.loading}
                      rowSelection={{
                        ...rowSelection,
                        hideSelectAll: true,
                      }}
                      rowKey="invoice_header_id"
                      scroll={{
                        x: 'max-content',
                        // y: 450,
                      }}
                      pagination={{
                        defaultCurrent: 1,
                        defaultPageSize: 100,
                        pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                      }}
                      summary={(pageData) => {
                        return (
                          <>
                            <Table.Summary.Row>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              {/* <Table.Summary.Cell >Other Credit : ${numeral(customerId && customerId[0]?.credit_balance).format("0,00,0")}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell >Unapplied Amount : ${numeral(customerId && customerId[0]?.unapplied_amount).format("0,00,0")}</Table.Summary.Cell>
                        <Table.Summary.Cell></Table.Summary.Cell> */}
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell></Table.Summary.Cell>
                              <Table.Summary.Cell>
                                <p style={{ textAlign: "right", margin: "0" }} className="totalquantity">
                                  ${total_balance.toLocaleString("en-US")}
                                </p>
                              </Table.Summary.Cell>
                            </Table.Summary.Row>
                          </>
                        );
                      }}
                    />
                  </>
                ) : (
                  <div className="no-Data">
                    {/* {} */}
                    <h1>No Data</h1>
                  </div>
                )
              ) : (
                loader && (
                  <div className="loader" style={{ marginTop: "20px" }}>
                    <Spin size="medium" />
                  </div>
                )
              )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerAccountStatement;






